import { Component, OnInit, ViewChild } from '@angular/core';
import { Ward } from './ward';
import { WardService } from '../../../services/ward.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../services/role.service';
@Component({
  selector: 'app-ward-manage',
  templateUrl: './ward-manage.component.html',
  styleUrls: ['./ward-manage.component.scss'],
})
export class WardManageComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  wardList: Ward[] = [];
  ward: Ward = new Ward();
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  isLoading: boolean = false;
  isEditing: boolean = false; // Track if form is in edit mode
  wardNumberError: string = ''; // Store ward number validation error
  isSubmitting: boolean = false; // Track form submission state

  constructor(
    private wardService: WardService,
    private toastr: ToastrService,
    private roleService: RoleService
  ) {}

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    this.getWards();
  }

  canPerformBatchDelete(): boolean {
    return this.roleService.hasRole('ROLE_MANAGER') || this.roleService.isSuperAdmin();
  }
  private async updateWards() {
    (await this.wardService.getWardListWithAssessmentCounts()).subscribe({
      next: (res) => {
        this.wardList = res;
        this.isSubmitting = false; // Reset submission state
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          // Call the dtTrigger to rerender again
          this.dtTrigger.next(null);
        });
      },
      error: (err) => {
        this.isSubmitting = false; // Reset submission state on error
        console.error('Error updating ward list:', err);
      }
    });
  }
  updateWard(updatedWard: Ward) {
    updatedWard = _.cloneDeep(updatedWard);
    this.ward = updatedWard;
    this.isEditing = true;
    this.wardNumberError = ''; // Clear any validation errors
    this.isSubmitting = false; // Reset submission state
    
    // Show success notification
    this.toastr.info('ওয়ার্ড সম্পাদনার জন্য প্রস্তুত', 'সম্পাদনা মোড');
    
    // Smooth scroll to form
    setTimeout(() => {
      const formElement = document.getElementById('ward-form');
      if (formElement) {
        formElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest'
        });
      }
    }, 100);
  }
  async deleteWard(wardId: number) {
    if (confirm('Are you sure you want to delete ?'))
      (await this.wardService.deleteWard(wardId)).subscribe({
        next: (res) => {
          // console.log('deleted successfully');
          // console.log(res);
          this.toastr.success('ওয়ার্ড সফলভাবে ডিলিট হয়েছে');
          this.updateWards();
        },
        error: (err) => {
          this.toastr.error('ডিলিট করতে সমস্যা হয়েছে');
        }
      });
  }

  async batchDeleteWardData(wardId: number, wardNumber: number) {
    const confirmed = confirm(
      `⚠️ সতর্কতা: এই অপারেশনটি ওয়ার্ড নং ${wardNumber} এর সমস্ত তথ্য স্থায়ীভাবে মুছে ফেলবে, যার মধ্যে রয়েছে:\n\n` +
      `• ওয়ার্ডের সমস্ত হোল্ডিং এসেসমেন্ট\n` +
      `• সমস্ত ট্যাক্স কালেকশন রেকর্ড\n` +
      `• ওয়ার্ডের সমস্ত সংশ্লিষ্ট ডেটা\n\n` +
      `এই অপারেশনটি পূর্বাবস্থায় ফেরানো যাবে না। আপনি কি নিশ্চিত যে আপনি এগিয়ে যেতে চান?`
    );
    
    if (confirmed) {
      (await this.wardService.batchDeleteWardData(wardId)).subscribe({
        next: (res) => {
          this.toastr.success(res.message || 'ওয়ার্ডের সমস্ত তথ্য সফলভাবে ডিলিট হয়েছে');
          console.log('Batch delete result:', res);
          this.updateWards();
        },
        error: (err) => {
          this.toastr.error(err.error?.message || 'ব্যাচ ডিলিট করতে সমস্যা হয়েছে');
          console.error('Batch delete error:', err);
        }
      });
    }
  }
  
  cancelEdit() {
    this.isEditing = false;
    this.ward = new Ward();
    this.wardNumberError = ''; // Clear validation errors
    this.isSubmitting = false; // Reset submission state
    this.toastr.info('সম্পাদনা বাতিল করা হয়েছে');
  }
  
  clearForm() {
    this.ward = new Ward();
    this.isEditing = false; // Reset edit mode
    this.wardNumberError = ''; // Clear validation errors
    this.isSubmitting = false; // Reset submission state
    // Clear any potential validation errors if using template-driven forms
    if (document.querySelector('form')) {
      const form = document.querySelector('form') as HTMLFormElement;
      form.classList.remove('ng-submitted');
    }
  }

  // Validate ward number for duplicates
  validateWardNumber() {
    this.wardNumberError = '';
    
    if (!this.ward.ward_number) {
      return;
    }

    // Check if ward number already exists (excluding current ward if editing)
    const existingWard = this.wardList.find(w => 
      w.ward_number === this.ward.ward_number && 
      (!this.isEditing || w.id !== this.ward.id)
    );

    if (existingWard) {
      this.wardNumberError = `ওয়ার্ড নং ${this.ward.ward_number} ইতিমধ্যে বিদ্যমান। অনুগ্রহ করে অন্য নম্বর ব্যবহার করুন।`;
    }
  }

  // Check if form is valid
  isFormValid(): boolean {
    return !!(this.ward.ward_number && this.ward.ward_name && !this.wardNumberError);
  }
  
  onSubmit() {
    // Validate form before submission
    this.validateWardNumber();
    
    if (!this.isFormValid()) {
      this.toastr.warning('অনুগ্রহ করে সকল প্রয়োজনীয় তথ্য সঠিকভাবে পূরণ করুন');
      return;
    }

    this.isSubmitting = true;

    if (this.ward.id) {
      // Update existing ward
      this.wardService.updateWard(this.ward).subscribe({
        next: (res) => {
          this.toastr.success('ওয়ার্ড সফলভাবে আপডেট হয়েছে');
          this.updateWards();
          this.clearForm();
        },
        error: (err) => {
          console.log(err);
          this.isSubmitting = false;
          
          // Handle specific duplicate error
          if (err.status === 409 && err.error?.error === 'DUPLICATE_WARD_NUMBER') {
            this.wardNumberError = err.error.message;
            this.toastr.error(err.error.message);
          } else {
            this.toastr.error(err.error?.message || 'আপডেট করতে সমস্যা হয়েছে');
          }
        },
      });
    } else {
      // Create new ward
      this.wardService.createWard(this.ward).subscribe({
        next: (res) => {
          this.toastr.success('ওয়ার্ড সফলভাবে তৈরি হয়েছে');
          this.updateWards();
          this.clearForm();
        },
        error: (err) => {
          console.log(err);
          this.isSubmitting = false;
          
          // Handle specific duplicate error
          if (err.status === 409 && err.error?.error === 'DUPLICATE_WARD_NUMBER') {
            this.wardNumberError = err.error.message;
            this.toastr.error(err.error.message);
          } else {
            this.toastr.error(err.error?.message || 'তৈরি করতে সমস্যা হয়েছে');
          }
        },
      });
    }
  }
  private async getWards() {
    this.isLoading = true;
    (await this.wardService.getWardListWithAssessmentCounts()).subscribe({
      next: (res) => {
        // console.log(res);
        this.wardList = res;
        this.isLoading = false;
        this.dtTrigger.next(null);
      },
      error: (err) => {
        console.error('Error loading wards:', err);
        this.isLoading = false;
        this.toastr.error('ওয়ার্ড তালিকা লোড করতে সমস্যা হয়েছে');
      }
    });
  }
}
